import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'countryCode'})
export class CountryCodePipe implements PipeTransform{
  transform(countryCode: string): any {
    if (countryCode === 'US') {
      return 'USA';
    } else if (countryCode === 'us') {
      return 'usa';
    }

    return countryCode;
  }
}
